export const formatProductPrice = (value: string | null, suffix = '') => {
  const price = Number(value?.replace(/[^\d.-]/g, ''))
  return Number.isFinite(price) ? `${price.toLocaleString('ko-KR')}${suffix}` : (value ?? '-')
}

export const hasProductPrice = (value: string | null): value is string => {
  return value != null && value.trim() !== ''
}
